import { useOnClickOutside } from 'components/utility/hooks/useOnClickOutside'
import React, { useCallback, useRef, useState } from 'react'

export const AutoCompleteField = ({
  label,
  labelExtractor,
  valueExtractor,
  icon = <i className="fa-light fa-solid fa-chevron-down dome-color-med-grey"></i>,
  required,
  placeholder,
  options,
  readOnly,
  onSelect,
  onChange,
}) => {
  const ref = useRef()
  const [open, setOpen] = useState(false)

  const handleSelect = useCallback(
    (value) => {
      setOpen(false)
      onSelect(value)
    },
    [onSelect]
  )

  const handleClickInside = useCallback(() => setOpen(false), [])
  useOnClickOutside(ref, handleClickInside)

  const toggleOpen = useCallback(() => setOpen((prev) => !prev), [])
  const inputValue = valueExtractor()

  return (
    <div ref={ref} className="dome-d-flex dome-flex-column auto-questionnaire-auto-complete-field">
      <div onClick={toggleOpen}>
        {label && (
          <label className="dome-p3 dome-color-med-grey">
            {label}
            {required && '*'}
          </label>
        )}
        <div className="auto-complete-field-search dome-cursor-pointer">
          <input
            value={inputValue}
            placeholder={placeholder}
            onChange={onChange}
            required={required}
            readOnly={readOnly}
          />
          {icon}
        </div>
      </div>
      {open && (
        <ul className="auto-complete-field-list">
          {options?.map((item, index) => {
            const itemLabel = labelExtractor(item)
            return (
              <li
                key={`${itemLabel}-${index}`}
                onClick={() => handleSelect(item)}
                className="auto-complete-field-list-item dome-cursor-pointer dome-p1 dome-color-darkest-grey dome-text-w300"
              >
                {itemLabel}
              </li>
            )
          })}
        </ul>
      )}
    </div>
  )
}
